export default __webpack_public_path__ + "static/media/book.fecd899c.jpg";